// Player-facing vocabulary for the TINY LEGENDS theme (see docs/DESIGN.md §5).
// Internal ids (gold, relics, heroes, skills, cells...) never change, so saves are unaffected by reskins.
export const TERMS = {
  game: 'Tiny Legends',
  player: 'Tuck',
  gold: 'Coins',
  gems: 'Gems',
  relics: 'Stardust',
  mana: 'Energy',
  heroes: 'Guardians',
  hero: 'Guardian',
  skills: 'Specials',
  skill: 'Special',
  tree: 'Sticker Book',
  skillPoints: 'Stickers',
  gear: 'Gear',
  pets: 'Pals',
  pet: 'Pal',
  petFood: 'Treats',
  artifacts: 'Treasures',
  prestige: 'Rewind',
  boss: 'Giant',
  tap: 'Tap',
} as const;

export const CLASS_LABEL = { melee: 'Warrior', ranged: 'Ranger', spell: 'Mage' } as const;
